<main class="bg-cover bg-no-repeat bg-[center_top] bg-[url('/bg/mobile-bg2.webp')] tabletLg:bg-[url('/bg/primary-bg.webp')] flex flex-col grow relative bg-dark content-center min-h-[40vh]">
  <div class="loader">
    <div class="relative content justify-center flex">
      <svg xmlns="http://www.w3.org/2000/svg" width="232" height="72" viewBox="0 0 232 52">
        <defs>
          <filter id="dotShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="3"/>
            <feOffset dx="0" dy="2" result="offset"/>
            <feFlood flood-color="rgba(0,0,0,1)" flood-opacity="0.5"/>
            <feComposite in2="offset" operator="in"/>
            <feMerge>
              <feMergeNode/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        <style>
          .dot_base {
            animation: dot_xe7Q 2s linear infinite;
          }
          .dot_1 {
            animation-delay: -1.75s;
          }
          .dot_2 {
            animation-delay: -1.5s;
          }
          .dot_3 {
            animation-delay: -1.25s;
          }
          .dot_4 {
            animation-delay: -1s;
          }
          .dot_5 {
            animation-delay: -0.75s;
          }
          .dot_6 {
            animation-delay: -0.5s;
          }
          .dot_7 {
            animation-delay: -0.25s;
          }


          @keyframes dot_xe7Q {
            93.75%,
            100% {
              r: 8px;
            }
            46.875% {
              r: 0.4px;
            }
          }
        </style>
        <circle class="dot_base" cx="9" cy="26" r="8" filter="url(#dotShadow)" />
        <circle class="dot_base dot_1" cx="41" cy="26" r="8" filter="url(#dotShadow)" />
        <circle class="dot_base dot_2" cx="73" cy="26" r="8" filter="url(#dotShadow)" />
        <circle class="dot_base dot_3" cx="105" cy="26" r="8" filter="url(#dotShadow)" />
        <circle class="dot_base dot_4" cx="137" cy="26" r="8" filter="url(#dotShadow)" />
        <circle class="dot_base dot_5" cx="169" cy="26" r="8" filter="url(#dotShadow)" />
        <circle class="dot_base dot_6" cx="201" cy="26" r="8" filter="url(#dotShadow)" />
      </svg>
    </div>
  </div>
</main>

<style>
  .dot_base {
    fill: #ff6000;
  }

  .loader {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-grow: 1;
    z-index: 1;
  }
</style>
